import {ScrollingModule} from "@angular/cdk/scrolling";
import {ChangeDetectionStrategy, Component, inject} from "@angular/core";
import {MatDivider} from "@angular/material/divider";
import {RouterOutlet} from "@angular/router";
import {SecurityService} from "@menu-security";
import {ErrorMessagePanelComponent} from "./ui/components/error-message-panel/error-message-panel.component";

import {ToolbarComponent} from "./ui/layout/toolbar/toolbar.component";

@Component({
    selector: "app-root",
    imports: [
        RouterOutlet,
        MatDivider,
        ToolbarComponent,
        ErrorMessagePanelComponent,
        ScrollingModule,
    ],
    templateUrl: "./app.component.html",
    styleUrl: "./app.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
    protected readonly securityService = inject(SecurityService);
}
